import { Desktop } from "common/MediaQueries"
import { useLayoutContext } from "layout/oldLayout/LayoutContext"
import { useLocation } from "react-router-dom"
import routes from "routes"
import styled, { css } from "styled-components"
import TotalPrice from "../bottomBar/totalPrice/TotalPrice"
import { STEPS_EN } from "../constants"
import OutOfStockBanner from "../OutOfStockBanner"
import PollutionAndSafety from "../pollutionAndSafety/PollutionAndSafety"

const StyledShopFooterContainer = styled.div<{
  $page: string
  $isShowRoomsScreens?: boolean
}>`
  position: relative;
  display: flex;
  justify-content: ${(p) =>
    p?.$page === STEPS_EN.order || p?.$page === STEPS_EN.payment
      ? "flex-end"
      : "space-between"};
  z-index: 1;
  ${(p) =>
    p.$isShowRoomsScreens &&
    css`
      flex-direction: column-reverse;
      align-items: center;
      gap: 20px;
    `}

  ${(p) => p.$page === STEPS_EN.color && "padding: 0 24px;"}

  > * {
    direction: rtl;
  }

  ${(p) => p.theme.breakpoints.down("sm")} {
    z-index: 999;
  }
`

const StyledPriceContainer = styled.div`
  min-width: 320px;
  width: 320px;
  border-radius: 5px;
  box-shadow: 0px 4px 4px 0px #00000040, 0px -1px 4px 0px #00000014;
  height: 91px;
  background: ${(p) => p.theme.colors.white};

  ${(p) => p.theme.breakpoints.down("sm")} {
    position: fixed;
    bottom: 1px;
    margin-bottom: 10px;
    width: calc(100% - 32px);
    left: 16px;
  }
`

const StyledPollutionContainer = styled.div`
  min-width: 408px;
  /* width: 408px; */
`

type ShopFooterProps = {
  hidePrice?: boolean
}

const ShopFooter = ({ hidePrice }: ShopFooterProps) => {
  const { pathname } = useLocation()
  const { isShowRoomsScreens } = useLayoutContext()

  return (
    <StyledShopFooterContainer
      $page={pathname}
      $isShowRoomsScreens={isShowRoomsScreens}
    >
      <Desktop>
        <StyledPollutionContainer>
          <PollutionAndSafety
            invertColor={pathname === routes.upholstery.path}
          />
        </StyledPollutionContainer>
      </Desktop>
      {!hidePrice && (
        <StyledPriceContainer>
          <TotalPrice />
          {(pathname === routes.detailing.path ||
            pathname === routes.color.path ||
            pathname === routes.upholstery.path ||
            pathname === routes.accessories.path) && (
              <OutOfStockBanner isColors={pathname === routes.color.path} />
            )}
        </StyledPriceContainer>
      )}
    </StyledShopFooterContainer>
  )
}

export default ShopFooter
